import React, { useState, useRef } from 'react'
import RoleForm from './RoleForm'
import RoleTable from './RoleTable'
import { filterRoles } from 'actions/roleActions'
import queryString from 'query-string'
import Snackbars from '../../snackbars/SnackBars'
import Spinner from '../../commons/Spinner'
import SecurityAdministrationLayout from '../../commons/SecurityAdministrationLayout'
import { useForm } from 'utils/customHooks/useForm'
import moment from 'moment'
import { putToApi } from 'actions'
import { ROLES_PATH } from '../../../constants'
import { VALUES } from 'utils/constants'

const RoleSearch = () => {
   const childRef = useRef()
   const [dataTable, setDataTable] = useState([])
   const [keyComponent, setKeyComponent] = useState(1)
   const [loading, setLoading] = useState(false)
   const [formBehavior, setFormBehavior] = useState({
      search: true,
      register: false,
      edit: false
   })
   const [isPopoverOpen, setIsPopoverOpen] = useState(true)
   const [message, setMessage] = useState({
      open: false,
      text: '',
      type: '',
      fontColor: ''
   })
   const queryInitial = {
      name: '',
      domain: '',
      initial_date: '',
      final_date: '',
      status: '',
      query: '',
      order: 'ASC',
      page: 0,
      size: 5,
      columnOrder: 'name'
   }
   const [queryForm, setQueryForm] = useState(queryInitial)
   const [paginationParams, setPaginationParams] = useState(
      VALUES.PAGING_ORDER_INITIAL_STATE
   )

   const searchRole = async params => {
      setIsPopoverOpen(false)
      await setLoading(true)
      setQueryForm(params)
      const urlParams = queryString.stringify(params)
      filterRoles(urlParams)
         .then(response => {
            if (response.status === 200 || response.status === 201) {
               setDataTable(response.data)
            } else {
               setMessage({
                  open: true,
                  text:
                     response.data?.message.length > 0
                        ? response.data.message
                        : 'Lo sentimos, hubo un problema al consultar el rol.',
                  type: 'error',
                  fontColor: '#fff'
               })
               setIsPopoverOpen(true)
            }
         })
         .catch(err => {
            setMessage({
               open: true,
               text:
                  err.data?.message?.length > 0
                     ? err.data.message
                     : 'Lo sentimos, hubo un problema al consultar el rol.',
               type: 'error',
               fontColor: '#fff'
            })
            setIsPopoverOpen(true)
         })
      setTimeout(() => {
         setLoading(false)
      }, 1000)
   }

   const editRoleAction = async payload => {
      delete payload.initialDate
      payload.finalDate = moment(payload.finalDate).format('YYYY-MM-DD')
      setMessage(old => ({ ...old, open: false }))

      try {
         const finalMoment = moment(payload.finalDate)
         if (!finalMoment.isValid()) {
            payload.finalDate = null
         }
         const editedRol = await putToApi(
            `${process.env.REACT_APP_ROLES_API}${ROLES_PATH}/${payload.id}`,
            payload
         )

         setDataTable([editedRol])
         setKeyComponent(keyComponent + 1)
         setMessage({
            open: true,
            text: 'El rol se editó correctamente.',
            type: 'info',
            fontColor: '#fff'
         })
         setIsPopoverOpen(false)
         setFormBehavior({
            search: true,
            register: false,
            edit: false
         })

         formData.id = ''
         formData.name = ''
         formData.description = ''
         formData.status = ''
         formData.initialDate = ''
         formData.finalDate = ''
         formData.domain = ''
      } catch (e) {
         setMessage({
            open: true,
            text:
               e?.data?.message ||
               'Lo sentimos, hubo un problema al guardar el rol.',
            type: 'error',
            fontColor: '#fff'
         })
         setIsPopoverOpen(true)
      }
   }

   const resetForm = () => {
      setQueryForm(queryInitial)
      setDataTable([])
      setPaginationParams(VALUES.PAGING_ORDER_INITIAL_STATE)
      setKeyComponent(key => key + 1)
   }
   const actionEdit = rowData => {
      setIsPopoverOpen(true)

      const initialDate = moment(rowData.initialDate, 'DD-MM-YYYY').format(
         'YYYY-MM-DDThh:mm:ssZ'
      )
      const date = moment(rowData.finalDate, 'DD-MM-YYYY').format(
         'YYYY-MM-DDThh:mm:ssZ'
      )

      const finalDate = moment(date).isValid() ? date : null

      if (formData) {
         formData.id = rowData?.id
         formData.name = rowData?.name
         formData.description = rowData?.description
         formData.status = rowData?.status
         formData.initialDate = initialDate
         formData.finalDate = finalDate
         formData.domain = rowData?.domain
      }

      setFormBehavior({
         search: false,
         register: false,
         edit: true
      })
   }

   const [formData, handleInputChange, setForm, reset] = useForm({
      name: '',
      description: '',
      status: '',
      initialDate: '',
      finalDate: '',
      domain: ''
   })

   return (
      <React.Fragment>
         <Spinner open={loading} />
         <SecurityAdministrationLayout
            form={
               <RoleForm
                  formData={formData}
                  handleInputChange={handleInputChange}
                  setForm={setForm}
                  reset={reset}
                  toSearch={searchRole}
                  key={keyComponent}
                  ref={childRef}
                  formBehavior={formBehavior}
                  editRoleAction={editRoleAction}
               />
            }
            table={
               <RoleTable
                  key={keyComponent}
                  dataTable={dataTable}
                  sortingStatus={Object.keys(queryForm) > 0}
                  order={paginationParams.order}
                  params={queryForm}
                  newParams={searchRole}
                  loading={loading}
                  isSearch={true}
                  formData={formData}
                  resetForm={resetForm}
                  formBehavior={formBehavior}
                  setFormBehavior={setFormBehavior}
                  setIsPopoverOpen={setIsPopoverOpen}
                  actionEdit={actionEdit}
               />
            }
            title={
               formBehavior.edit
                  ? 'Editar Rol de Usuario'
                  : 'Consultar Rol de Usuario'
            }
            popoverProp={isPopoverOpen}
            setPopoverProp={value => setIsPopoverOpen(value)}
         />
         {message.open && (
            <Snackbars
               severity={message.type}
               fontColor={message.fontColor}
               message={message.text}
            />
         )}
      </React.Fragment>
   )
}

export default RoleSearch
